<template>
    <div id="index">
        <router-link :to="{name: 'new_permission_group'}" class="ui green button">
            <i class="plus icon"></i>
            {{ $t('ui.page_titles.new_permission_group') }}
        </router-link>
        <table class="ui celled selectable table">
            <thead>
                <tr>
                    <th>{{ $t('models.attributes.permission_groups.name') }}</th>
                    <th colspan="3"></th>
                </tr>
            </thead>
            <tbody v-if="permission_groups && permission_groups.length > 0">
                <tr
                    is="TableItem"
                    v-for="permission_group in permission_groups"
                    :permission_group="permission_group"
                    >
                </tr>

            </tbody>
            <tbody v-else>
                <tr>
                    <td style="text-align: center;" colspan="100%">{{ $t('ui.general.no_data') }}</td>
                </tr>
            </tbody>
        </table>

        <div
            is="Paginator"
            :total_pages="total_pages"
            :current_page="current_page"
            change_page_channel="index_page"
            >
        </div>
    </div>
</template>

<script>
import TableItem from './index_table_item.vue'
import Paginator from '@toolbox/pagination/paginator.vue'

export default {
    name: "PermissionGroupsIndex",
    data: function () {
        return {
            is_initializing: false,
            search: "",
            errors: []
        }
    },
    mounted: function() {
        console.log("INDEX permission_groups");
        this.$store.state.provider.permission_groups_module.current = {
            "name": "",
            "permission_ids": [],
        };

    },
    computed: {
        permission_groups: function() {
            return this.$store.state.provider.permission_groups_module.permission_groups;
        },
        current_permission_group: function() {
            return this.$store.state.provider.permission_groups_module.current_permission_group;
        },
        current_page: function() {
            return this.$store.state.provider.permission_groups_module.current_page;
        },
        total_pages: function() {
            return this.$store.state.provider.permission_groups_module.total_pages;
        },
    },
    methods: {
    },
    components: {
        TableItem,
        Paginator
    }
}
</script>
